import axios from "axios";

const CONTACT_FORM_URL = "https://api-v1.jvlands.com/api/contactForm/save";

export async function submitContactFormCall(data) {
  return axios.post(CONTACT_FORM_URL, data, {
    headers: {
      "Content-Type": "application/json",
    },
    ["axios-retry"]: {
      retries: 0,
    },
  });
}
